import React, { useState } from 'react'
import { Badge, Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';
import { userService } from 'services/userService';
import { apiUrls } from 'constants/apiUrls';
import { BiLogInCircle } from 'react-icons/bi';
import { BsLockFill } from 'react-icons/bs';
import { useAuth } from 'hooks/AuthProvider';
import { appRoutesUrls } from 'constants/appRoutesUrls';

const Login = () => {
    const navigate = useNavigate();
    const [message, setMessage] = useState();
    const [user, setUser] = useState({ username: '', password: '' });
    const { saveUserInfo } = useAuth();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUser((preValue) => {
            return {
                ...preValue,
                [name]: value
            }
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setMessage(null);
        if (user.username && user.password) {
            userService.authenticateUser(apiUrls.authenticateUser(), user).then((res) => {
                if (res) {
                    saveUserInfo(res);
                    navigate(appRoutesUrls.admin());
                    //const decoded = jwtDecode(res);
                }
                else
                    setMessage('Invalid username or password.');
            });
        } else {
            setMessage('Username and Password Required.');
        }
    }

    return (
        <>
            {/* <SectionWrapper>
                <motion.section animate={{ y: 10 }} style={{ padding: '25px 0' }}> */}
            <Container>
                <Row className="justify-content-center d-flex align-items-center mh-100vh">
                    <Col md={6} xl={4}>
                        <Card className="card-form mt-2 mb-2">
                            <Card.Body className='pt-0'>
                                <Card.Title className='fs-22 text-center'>
                                    <h4 className="lr-title">SHREE KRISHNA XEROX</h4>
                                    <BsLockFill size={22} /> LOGIN
                                </Card.Title>
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">
                                            Username
                                        </Form.Label>
                                        <Col sm="9">
                                            <Form.Control
                                                type="text"
                                                maxLength={20}
                                                name='username'
                                                value={user.username}
                                                onChange={handleChange} />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} className="mb-3">
                                        <Form.Label column sm="3">
                                            Password
                                        </Form.Label>
                                        <Col sm="9">
                                            <Form.Control
                                                type="password"
                                                maxLength={20}
                                                name='password'
                                                value={user.password}
                                                onChange={handleChange} />
                                        </Col>
                                    </Form.Group>
                                    {message && (
                                        <Form.Group as={Row} className="mb-3">
                                            <Col sm={{ span: 9, offset: 3 }}>
                                                <Badge bg="light" text="danger">{message}</Badge>
                                            </Col>
                                        </Form.Group>
                                    )}
                                    <Form.Group as={Row}>
                                        <Col className='text-center'>
                                            <Button type="submit" className='mw-100'>
                                                <BiLogInCircle size={24} /> Login
                                            </Button>
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {/* </motion.section>
            </SectionWrapper> */}
        </>
    )
}

export default Login;